export class CheckInsSelectors {
  static checkIns = 'checkIns';
  static dayOfWeekCheckIns = 'dayOfWeekCheckIns';
  static monthly = 'monthly';
}